/**
 * Semantic linter rule for VSlider: the `Range` property-order hazard, as in `hslider/linter.ts`,
 * which holds the `range.cpp` derivation. Range has no authorable intermediate type in
 * `NODE_BASE_TYPES` to hang one shared rule off, so each leaf registers its own rule name over
 * the shared order arithmetic (`shared/rangeLinter.ts`).
 */
import { ruleRegistry } from '../../../../linter/RuleRegistry.js';
import { rangeOrderHazard } from '../shared/rangeLinter.js';
import { armDiagnostic, armEmits } from '../../../../linter/ruleArms.js';
const arms = {
    propertyOrder: {
        severity: 'warning',
        ruleName: 'vslider-property-order',
        grounding: { kind: 'engine', at: 'range.cpp:106' },
    },
};
function checkVSliderPropertyOrder(context) {
    const { node } = context;
    const laterTriggers = rangeOrderHazard(node.rawProperties);
    if (!laterTriggers)
        return [];
    return [
        armDiagnostic(arms.propertyOrder, node, `'value' is authored before ${laterTriggers.join(', ')} on ${node.name}. Godot applies a ` +
            `node's properties in the order the file lists them (SceneState::instantiate, ` +
            `scene/resources/packed_scene.cpp), and Range::set_min/set_max/set_page each re-clamp ` +
            `'value' against whatever bounds exist at that moment (scene/gui/range.cpp:211-266) — so ` +
            `'value' can be silently clamped against stale (default) bounds, and a later ` +
            `min_value/max_value/page line cannot recover the original intent. Move 'value' after ` +
            `${laterTriggers.join(', ')}.`),
    ];
}
const vSliderPropertyOrderRule = {
    meta: {
        name: 'vslider-property-order',
        description: "Warns when a VSlider authors 'value' in a file order Range's own min_value/max_value/page " +
            'setters silently re-clamp against.',
        category: 'validation',
        applicableNodeTypes: ['VSlider'],
        emits: armEmits(arms),
    },
    check: checkVSliderPropertyOrder,
};
ruleRegistry.register(vSliderPropertyOrderRule);
//# sourceMappingURL=linter.js.map